code

<template>

  <div class="container">
    <div class="row fh-row justify-content-center">
      <div class="col-md-6 pl-0 pr-0 align-self-center">
        <mdb-card class="z-depth-1 card-height">
          <mdb-card-header color="white">
            <div class="container-fluid">
              <div class="row">
                <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                  <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                  <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                  <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                </div>
              </div>
            </div>
          </mdb-card-header>
          <mdb-card-body class="text-center">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 align-self-center">
                  <mdb-progress class="mb-3" style="width: 100%; float:left"
                                :height="20" :value="$store.state.step/$store.state.totalSteps * 100">
                    {{ $store.state.step }}/{{ $store.state.totalSteps }}
                  </mdb-progress>
                </div>
              </div>
                <div class="row hh-row">
                  <div class="col-12 align-self-center mb-3">
                    <h4>{{ $t("mobileNumMsg") }}</h4>
                  </div>
                  <div class="col-12 align-self-center">
                    <i class="fa-phone fas fa-4x text-dark" />
                  </div>
                  <div class="col-12 align-self-center">
                    <mdb-input
                        v-model="mobile_number"
                        :label="$t('mobileNumber')"
                        size="lg"
                        outline
                        :small="$t('registeredWithCNIC')"
                        :class="validateMobileNumber() === false? 'is-invalid': 'is-valid'"
                        class="mt-4 input-text-center" type="text" placeholder="03221234567" maxlength="11" />
                    <div class="invalid-feedback">{{ $t("validMobileMsg") }}</div>
                  </div>
                </div>
                <transition name="slide-fade">
                  <p class="text-danger" v-if="message">{{ $t("mobileNotVerifiedMsg") }}<br />{{ $tc("retriesLeft", message) }}</p>
                </transition>
            </div>
          </mdb-card-body>
          <mdb-card-footer>
            <div class="col-12 align-self-center">
              <div class="row justify-content-center">
                <div class="col-md-12 mb-1 ">
                  <mdb-btn
                      :disabled="isValidMobile"
                      style="font-size: 15px" block color="primary" class="next-btn" size="md" @click="verifyMobileNumber">
                    {{ $t("next") }}
                    <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right text-white"></i>
                  </mdb-btn>
                </div>
              </div>
            </div>
          </mdb-card-footer>
        </mdb-card>
      </div>
    </div>
    <div id="overlay" v-if="spinner">
      <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p>{{ $t("waitMsg") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {i18n} from "../../translations";

export default {
  name: "MobileVerification",
  data() {
    return {
      spinner: false,
      mobile_number: '',
      message: null,
      cities: [],
      pattern: /^03[0-9]{2}(?!1234567)(?!1111111)(?!7654321)[0-9]{7}$/,
    };
  },
  mounted() {
    i18n.locale = this.$store.state.language
    this.$store.commit('assignStep', this.$route.path)
  },
  computed: {
    isValidMobile() {
      return [false, null, ''].includes(this.validateMobileNumber())
    }
  },
  methods: {
    verifyMobileNumber() {
      this.message = null
      if (this.validateMobileNumber()) {
        this.spinner = true;
        let formData = new FormData();
        formData.append('session', this.$store.state.session_id);
        formData.append('mobile_number', this.mobile_number);
        this.$http.post("/verify-mobile-number", formData).then(r => {
          if (r.data && r.data.mobile_verified) {
            this.spinner = false
            if (r.data.mobile_verified.status === false) {
              if (parseInt(r.data.mobile_verified.retries_left) > 0) {
                this.message = r.data.mobile_verified.retries_left
              } else {
                this.$router.push('/complete')
              }
            } else if (r.data.mobile_verified.status === true) {
              const urlSearchParams = new URLSearchParams(window.location.search);
              const params = Object.fromEntries(urlSearchParams.entries());
              this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params})
            }
          }
        }).catch(err => {
          this.handleError(err)
        })
      }

    },
    validateMobileNumber() {
      return this.mobile_number && this.pattern.test(this.mobile_number.trim())
    },
    handleError(err) {
      this.spinner = false;
      if (err.response.status === 400){
        if ('non_field_errors' in err.response && err.response.non_field_errors.length>0){
          this.showError(err.response.non_field_errors[0])
        }
        else if ('data' in err.response){
          if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length>0){
            this.showError(err.response.data.non_field_errors[0])
          }
          else{
            this.showError(JSON.stringify(err.response.data))
          }

        }
        else{
          this.showError(JSON.stringify(err.response))
        }
      } else if (err.response && err.response.status === 401) {
        this.$router.push('/expired')
      }
      else {
        this.showError(err.response)
      }
    },
    showError(message, cancelButton=false) {
      const options = {
        title: message,
        text: this.$t("retryQuestion"),
        icon: 'question',
        showCancelButton: cancelButton,

        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false,
        customClass: {
          confirmButton: "btn btn-primary btn-md ripple-parent",
          cancelButton: "btn  btn-md ripple-parent"
        },
        buttonsStyling: false,
      };

      this.$swal.fire(options).then(res => {
        if (res.value) {
          window.location.reload();
          // eslint-disable-next-line no-undef
        }
      })

    },
  }
}
</script>

<style scoped>

</style>
